import { clsx } from "clsx";
import type { ReactNode } from "react";

type PanelProps = {
  title?: ReactNode;
  description?: ReactNode;
  action?: ReactNode;
  className?: string;
  children?: ReactNode;
  bodyClassName?: string;
};

export function Panel({
  title,
  description,
  action,
  className,
  bodyClassName,
  children,
}: PanelProps) {
  return (
    <section
      className={clsx(
        "rounded-lg border border-border bg-surface-raised",
        className,
      )}
    >
      {(title || description || action) && (
        <header className="flex items-start justify-between gap-4 border-b border-border-subtle px-5 py-3">
          <div className="space-y-0.5">
            {title && <h2 className="text-sm font-medium text-foreground-primary">{title}</h2>}
            {description && (
              <p className="text-xs text-foreground-secondary">{description}</p>
            )}
          </div>
          {action && <div className="shrink-0">{action}</div>}
        </header>
      )}
      <div className={clsx("px-5 py-4", bodyClassName)}>{children}</div>
    </section>
  );
}
